.preview {
  display: flex;
  flex-direction: column;
  gap: var(--sp-3);
}

/* `panelHead`, not `head`: `experience-adoption` counts `.page/.head/.title`
   as the PAGE-shell recipe every console page rewrites, and this is a panel
   inside a record. Adding to that census would make it say something it does
   not mean. */
.panelHead {
  display: flex;
  flex-direction: column;
  gap: var(--sp-2);
}

.widths {
  display: flex;
  flex-wrap: wrap;
  gap: var(--sp-1);
}

/* The width buttons are a segmented control rather than three loose buttons:
   they are one choice with three answers, and `aria-pressed` says which. */
.width,
.widthOn {
  align-items: baseline;
  gap: var(--sp-1);
  /* 44px, which #1744 point 10 asks for by name. The shared Button's `md` is
     36px, and that is the estate's business rather than something to change
     from here — the HOST owns its own layout, so the floor is applied to this
     control and nothing else moves. Measured in the browser: it was 36px and
     the e2e caught it. */
  min-height: 44px;
}

.widthOn {
  font-weight: 600;
}

/* `--focus-ring`, never `--brand`. A focus indicator drawn with a customer
   token puts a WCAG 1.4.11 conformance floor under customer control — the
   fleet measured Coccolare dark at 1.71:1 — and @solum/experience derives and
   CLAMPS this one. `focus-ring.test.ts` caught exactly this line. */
/* The shared Button owns the focus ring, the 44px target and the hover state.
   What is left here is only what makes three buttons read as ONE choice. */

.px {
  color: var(--muted);
  font-size: var(--fs-sm);
  font-variant-numeric: tabular-nums;
}

.audience {
  margin: 0;
  color: var(--ink);
  font-size: var(--fs-sm);
}

/* The stage scrolls horizontally rather than letting a 1120px frame widen the
   record: the preview must never be the reason the page scrolls sideways. */
.stage {
  overflow-x: auto;
  padding-bottom: var(--sp-1);
}

  /* MEASURED white-on-white (#2156): this sits inside a --surface Surface, which paints the
     same --surface it does, so its ground separates it from nothing. F-43's
     exception is a declared line, and this is one. */
.frame { border: 1px solid var(--hair);
  border-radius: var(--r-md);
  background: var(--surface);
  padding: var(--sp-4);
}

.caveat {
  margin: 0;
  color: var(--muted);
  font-size: var(--fs-sm);
}

@media (prefers-reduced-motion: reduce) {
  .width,
  .widthOn {
    transition: none;
  }
}
